import { httpPost } from "../../services/api";

export const sdkGenerateAccessToken = async ({
  publicApiKey,
}: {
  publicApiKey: string;
}) => {
  return httpPost<{ data: { access_token: string } }>(
    "vault/generate-access-key/",
    undefined,
    false,
    {
      "x-public-key": publicApiKey,
    }
  ).then((res) => res.data.access_token);
};
